import React from 'react';
import StunningCard from './components/StunningCard';
import './App.css';

function App() {
  return (
    <div>
      <StunningCard />
    </div>
  );
}

export default App;
